import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/retail/RetailClient.tsx");
